import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {sortableContainer, sortableElement, sortableHandle} from 'react-sortable-hoc';

const Draggable = sortableContainer(({ children }) => children);
export const SortableItem = sortableElement(({ children }) => children);
export const SortableHandle = sortableHandle(({ children, ...props }) => children);

export class Sortable extends Component {
  static propTypes = {
    onSortEnd: PropTypes.func.isRequired
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    this.props.onSortEnd(oldIndex, newIndex);
  };

  render() {
    const { ...props } = this.props;
    return <Draggable pressDelay={50} {...props} onSortEnd={this.onSortEnd} />;
  }
}
